module.exports = __webpack_public_path__ + "static/media/profile-picture-2.487133c5.jpg";